// Card.tsx
import React from 'react';
import { Container, Grid, Card as MuiCard, CardContent, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomSVGBlu from './common/CustomizeSvgBlu';

const Card: React.FC = () => {
  const navigate = useNavigate();

  const openDashboardFor = (country: 'uk' | 'india') => {
    // navigate to a country-specific route using query parameters
    navigate(`/dashboard?country=${country}`);
  };

  return (
    <div className='card_wrapper'>
      <Container sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <Box sx={{ mb: 5 }}><CustomSVGBlu /></Box>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={4}>
            <MuiCard onClick={() => navigate('/dashboard?country=uk')} sx={{ p: 2, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 300, gap: 2, cursor: "pointer" }}>
              <CardContent sx={{ p: 0 }}>
                <Box component="img" src="https://flagcdn.com/w320/gb.png" alt="UK Flag" sx={{ width: 130, height: 100, objectFit: "cover", borderRadius: 2, mb: 2 }} />
                <Typography variant="h5" fontWeight="bold">United Kingdom</Typography>
              </CardContent>
            </MuiCard>
          </Grid>

          <Grid item xs={12} md={4}>
            <MuiCard onClick={() => navigate('/dashboard?country=india')} sx={{ p: 2, textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 300, gap: 2, cursor: "pointer" }}>
              <CardContent sx={{ p: 0 }}>
                <Box component="img" src="https://flagcdn.com/w320/in.png" alt="India Flag" sx={{ width: 130, height: 100, objectFit: "cover", borderRadius: 2, mb: 2 }} />
                <Typography variant="h5" fontWeight="bold">India</Typography>
              </CardContent>
            </MuiCard>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Card;
